import { useSession } from "../features/organization/useSession";

/**
 * Check whether the current user holds a specific permission.
 * Returns `false` while the session is still loading (defensive default).
 */
export function usePermission(key: string): boolean {
  const { session } = useSession();
  if (!session) return false;
  return session.permissions.includes(key);
}
